/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IPresentationsMethods,
  PresentationsService,
  BandRouteService,
  IBandRouteMethods,
  BandInitialService,
  IBandInitialMethods,
} from "./components";

export type BandRouteLiveMapPageAgent = IHeaderMethods &
  ISettingsMethods &
  IPresentationsMethods &
  IBandInitialMethods &
  IBandRouteMethods &
  IStaticPageContentMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new BandInitialService(),
    new PresentationsService(),
    new BandRouteService(),
  ];
};

let agentInstance: BandRouteLiveMapPageAgent | null = null;

export const getAgent = () => {
  if (!agentInstance) {
    agentInstance = createAgent<BandRouteLiveMapPageAgent>({
      plugins: getPlugins(),
    });
  }
  return agentInstance;
};
